module.exports = __webpack_public_path__ + "img/deleted.2d6be478.png";